import { useState, useEffect } from "react";
import useReveal from "../hooks/useReveal";
import { X } from "lucide-react";
import { gallery as mockGallery } from "../mock/mock";
import { getGallery, assetUrl } from "../lib/api";

export default function Gallery() {
  const [ref, inView] = useReveal();
  const [active, setActive] = useState(null);
  const [gallery, setGallery] = useState(mockGallery);

  useEffect(() => {
    getGallery()
      .then((data) => {
        if (Array.isArray(data) && data.length) {
          setGallery(data.map((d) => ({ src: assetUrl(d.image), caption: d.caption })));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section id="gallery" className="py-24 md:py-32 bg-[#F2ECE2]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div ref={ref} className={`text-center max-w-2xl mx-auto mb-16 reveal ${inView ? "in-view" : ""}`}>
          <p className="text-[#A17E4A] tracking-[0.25em] uppercase text-xs mb-4">Our Work</p>
          <h2 className="font-serif text-3xl md:text-5xl text-[#2A2521] mb-5">
            Transform Your Space
          </h2>
          <p className="text-[#6B6259] text-lg">
            A diverse range of personalized solutions, each crafted with meticulous attention to detail.
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {gallery.map((g, i) => (
            <button
              key={i}
              onClick={() => setActive(g)}
              className={`group relative mb-5 block w-full overflow-hidden rounded-xl reveal ${
                inView ? "in-view" : ""
              }`}
              style={{ animationDelay: `${(i % 3) * 100}ms` }}
            >
              <img
                src={g.src}
                alt={g.caption}
                className="w-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400 flex items-end p-5">
                <span className="text-white font-serif text-lg">{g.caption}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {active && (
        <div
          className="fixed inset-0 z-[60] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button className="absolute top-6 right-6 text-white/80 hover:text-white">
            <X className="w-8 h-8" />
          </button>
          <figure className="max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <img src={active.src} alt={active.caption} className="w-full max-h-[80vh] object-contain rounded-lg" />
            <figcaption className="text-center text-white/80 mt-4 font-serif text-lg">
              {active.caption}
            </figcaption>
          </figure>
        </div>
      )}
    </section>
  );
}
